import PlayerProfile from './PlayerProfile';

function Header() {
  return (
    <div className="h-full">
      <PlayerProfile />
    </div>
  );
}

export default Header;
